import "assets/css/filter.css";

export type FilterProps = {
    open: boolean;
    clear: Function;
    setOpen: React.Dispatch<React.SetStateAction<boolean>>;
    children: React.ReactNode;
};
const Filter = ({ open, setOpen, clear, children }: FilterProps) => {
    // top filter bar
    // side bar
    return (
        <div
            className={`${open && "open"} filter h-full overflow-auto shadow-md bg-neutral-100 dark:bg-momeento-300 w-full lg:w-1/4 animate-200ms flex flex-col`}
        >
            <div className="w-full lg:hidden flex justify-between items-center gap-5 px-4 mb-auto py-2">
                <h2 className="font-medium text-momeento-50">Filter Results</h2>
                <button
                    className="bg-transparent text-momeento-50"
                    onClick={() => setOpen(false)}
                >
                    Close
                </button>
            </div>
            <div className="w-full h-full flex flex-col gap-7 overflow-auto">
                {children}
            </div>
            <div className="w-full flex justify-between items-center gap-5 mt-auto pt-2 pb-5 bg-white dark:bg-momeento-400">
                <button
                    className="bg-transparent text-momeento-50 py-1 px-4"
                    onClick={() => setOpen(false)}
                >
                    Apply Filter
                </button>
                <button
                    className="bg-transparent text-momeento-50 py-1 px-4"
                    onClick={() => clear()}
                >
                    Clear
                </button>
            </div>
        </div>
    );
};

export default Filter;
